import { Loader2, Save, SquarePen, X } from "lucide-react"
import { useState } from "react"
import { toast } from "sonner"

import { Button } from "@ui/button"
import { Input } from "@ui/input"
import { useUserSession } from "@session/UserSession"

import { CollectionItem } from "@vertesia/common"

interface UpdateReportTitleInputProps {
    program: CollectionItem
    onUpdate: (value: string) => void
}
export function UpdateReportTitleInput({ program, onUpdate }: Readonly<UpdateReportTitleInputProps>) {
    const { store } = useUserSession()

    const [isUpdating, setIsUpdating] = useState<boolean>(false)
    const [titleUpdate, setTitleUpdate] = useState<boolean>(false)
    const [updatedTitle, setUpdatedTitle] = useState<string>("")
    
    const handleOpenTitleUpdate = () => {
        setUpdatedTitle(program.name)
        setTitleUpdate(true)
    }

    const handleSaveTitleUpdate = () => {
        if (!store || !updatedTitle) {
            return
        }

        setIsUpdating(true)
        store.collections.update(program.id, { name: updatedTitle })
            .then(() => {
                onUpdate(updatedTitle)
                handleCloseTitleUpdate()
            })
            .catch((error) => {
                toast.error("Program update error", {
                    description: error.message || "An error occurred while updating the program.",
                    duration: 3000
                })
            })
            .finally(() => {
                setIsUpdating(false)
            })
    }

    const handleCloseTitleUpdate = () => {
        setUpdatedTitle("")
        setTitleUpdate(false)
    }

    return (
        <>
            {
                titleUpdate ? (
                    <>
                        <Input value={updatedTitle} onChange={(e) => setUpdatedTitle(e.target.value)} className="h-7" disabled={isUpdating} />
                        <Button variant={"ghost"} size={"xs"} onClick={handleSaveTitleUpdate} disabled={isUpdating || !updatedTitle?.length}>
                            { isUpdating ? <Loader2 className="animate-spin motion-safe:animate-[spin_3s_linear_infinite]" /> : <Save /> }
                        </Button>
                        {
                            !isUpdating && (
                                <Button variant={"ghost"} size={"xs"} onClick={handleCloseTitleUpdate} disabled={isUpdating}>
                                    <X />
                                </Button>
                            )
                        }
                    </>
                ) : (
                    <>
                        <span className="text-lg font-medium">
                            {program.name}
                        </span>
                        <Button variant={"ghost"} size={"xs"} onClick={handleOpenTitleUpdate}>
                            <SquarePen />
                        </Button>
                    </>
                )
            }
        </>
    )
}